import { Coins } from "lucide-react";

const money = (n) => Number(n || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const int = (n) => Number(n || 0).toLocaleString("pt-BR", { maximumFractionDigits: 2 });

// Saldo em R$ — objetivo, monoespaçado. Prefixo "R$" apagado, número em destaque.
export function Money({ value, sign = false, className = "", testid }) {
  const v = Number(value || 0);
  const tone = sign ? (v > 0 ? "text-emerald-500" : v < 0 ? "text-primary" : "") : "";
  return (
    <span className={`inline-flex items-baseline gap-1 ${className}`} data-testid={testid}>
      <span className="text-[0.62em] font-medium text-muted-foreground">R$</span>
      <span className={`font-num font-semibold tabular-nums ${tone}`}>{sign && v > 0 ? "+" : ""}{money(v)}</span>
    </span>
  );
}

// Créditos — token interno da marca: badge vermelho com ícone.
export function Credits({ value, className = "", testid }) {
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 rounded-md border border-primary/30 bg-primary/15 px-2.5 py-1 font-num text-sm font-bold leading-none text-primary ${className}`}
    >
      <Coins className="h-3.5 w-3.5" /> {int(value)}
    </span>
  );
}
